module.exports = __webpack_public_path__ + "img/zimizishu.4d7c7eb5.jpg";